import { useEffect, useState } from "react";
import { Modal, Button, Typography, Card, List, Empty } from "antd";
import {
	CheckCircleOutlined,
	BellOutlined,
	ClockCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const NotificationModal = ({ isModalVisible, setIsModalVisible }) => {
	const [notifications, setNotifications] = useState([
		{
			message: "AI-generated descriptions are ready!",
			products: [
				{ name: "T-shirt", status: "Completed", timeTaken: "12s" },
				{ name: "Sneakers", status: "Completed", timeTaken: "9s" },
				{ name: "Backpack", status: "Completed", timeTaken: "15s" },
			],
			totalTime: "36s",
			timestamp: new Date().toLocaleString(),
		},
		{
			message: "AI-generated descriptions are ready!",
			products: [
				{ name: "T-shirt", status: "Completed", timeTaken: "12s" },
				{ name: "Sneakers", status: "Completed", timeTaken: "9s" },
				{ name: "Backpack", status: "Completed", timeTaken: "15s" },
			],
			totalTime: "36s",
			timestamp: new Date().toLocaleString(),
		},
		{
			message: "AI-generated descriptions are ready!",
			products: [
				{ name: "T-shirt", status: "Completed", timeTaken: "12s" },
				{ name: "Sneakers", status: "Completed", timeTaken: "9s" },
				{ name: "Backpack", status: "Completed", timeTaken: "15s" },
			],
			totalTime: "36s",
			timestamp: new Date().toLocaleString(),
		},
		{
			message: "AI-generated descriptions are ready!",
			products: [
				{ name: "T-shirt", status: "Completed", timeTaken: "12s" },
				{ name: "Sneakers", status: "Completed", timeTaken: "9s" },
				{ name: "Backpack", status: "Completed", timeTaken: "15s" },
			],
			totalTime: "36s",
			timestamp: new Date().toLocaleString(),
		},
	]);
	const navigate = useNavigate();

	// Close modal
	const handleClose = () => {
		setIsModalVisible(false);
	};

	return (
		<Modal
			title={
				<>
					<CheckCircleOutlined style={{ color: "green", marginRight: 8 }} />
					AI Bulk Generation Notifications
				</>
			}
			open={isModalVisible}
			onCancel={handleClose}
			footer={[
				<Button key="ok" type="primary" onClick={handleClose}>
					Close
				</Button>,
			]}
		>
			{notifications.length > 0 ? (
				<List
					dataSource={notifications}
					renderItem={(item, index) => (
						<Card
							key={index}
							hoverable
							style={{ marginBottom: 10, cursor: "pointer" }}
							onClick={() => navigate("/bulk-AI-generation", { state: { details: item } })}
						>
							<Title level={5}>{item.message}</Title>
							<Text strong>🛍️ Products:</Text> {item.products.length} <br />
							<Text strong>⏳ Time Taken:</Text> {item.totalTime} <br />
							<Text strong>
								<ClockCircleOutlined style={{ marginRight: 5 }} />
								{item.timestamp}
							</Text>
						</Card>
					)}
				/>
			) : (
				<Empty
					image={<BellOutlined style={{ fontSize: 40, color: "#ccc" }} />}
					description="No notifications yet"
				/>
			)}
		</Modal>
	);
};

export default NotificationModal;
